import React from 'react'
import { useStyles } from './styles'
import wheat from 'src/assets/png/wheat.png'
import { CowIcon } from 'src/assets/svg'
import { PastureDto } from 'src/dto/pasture.dto'

type CardProps = {
  data: PastureDto
  onClick?: () => void
}
export const Card = ({ data, onClick }: CardProps) => {
  const styles = useStyles()

  return (
    <div className={styles.cardContainer} onClick={onClick}>
      <div className={styles.cardHeader}>
        <span>
          <img src={wheat} alt='Wheat' />
        </span>
        <span>{data.area} ha</span>
      </div>
      <div className={styles.cardContent}>
        <span>{data.descricao}</span>
      </div>
      <div className={styles.cardFooter}>
        <CowIcon />
        <span>{data.animais ? data.animais.length : 0}</span>
      </div>
    </div>
  )
}

// pedir pro andre retonar a quantidade de animais no local
